import Axios from "@app/api/axios";
import { PERMISSIONS } from "@utils/constant";

const permissionsService = () => Axios.get(`${PERMISSIONS}?per_page=100`);

export default permissionsService;

export const permissionsServiceById = id =>
  Axios.get(`${PERMISSIONS}?filter[id]=${id}`);
